<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <CCard>
    <div
      class="card-header bg-primary font-weight-bold text-white"
      style="display: flex; align-items: center"
    >
      Data Anggota
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.push('/keanggotaan/data-anggota/unverified')"
        >Kembali</Button
      >
    </div>
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item border-0">
        <router-link
          :to="
            '/keanggotaan/data-anggota/data-diri/' + this.$route.params.id_user
          "
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          style="background-color: #486ba7;"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          aria-controls="home"
          aria-selected="true"
          >Data Anggota</router-link
        >
      </li>
      <li class="nav-item border-0">
        <router-link
          :to="
            '/keanggotaan/data-anggota/data-sertifikasi/' +
            this.$route.params.id_user
          "
          style="background-color: #214073 !important"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          aria-controls="home"
          aria-selected="true"
          >Data Sertifikasi</router-link
        >
      </li>

      <li class="nav-item border-0">
        <router-link
          :to="
            '/keanggotaan/data-anggota/data-rpl/' + this.$route.params.id_user
          "
          style="background-color: #214073 !important"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          aria-controls="profile"
          aria-selected="false"
          >Data RPL</router-link
        >
      </li>
      <li class="nav-item border-0">
        <router-link
          :to="'/keanggotaan/data-anggota/data-pelatihan/' + this.$route.params.id_user"
          style="background-color: #214073 !important"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          aria-selected="false"
          >Data Pelatihan</router-link
        >
      </li>
      <li class="nav-item border-0">
        <router-link
          :to="
            '/keanggotaan/data-anggota/data-sanksi/' +
            this.$route.params.id_user
          "
          style="background-color: #214073 !important"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          aria-selected="false"
        >
          Sanksi
        </router-link>
      </li>
    </ul>
    <CCardBody>
      <CRow>
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-3 mt-3 px-0">
          <!-- Tabs -->
          <div class="card border-0">
            <h5 class="card-header text-bold">Profile Settings</h5>
            <ul class="list-group list-group-flush">
              <li class="list-group-item">
                <router-link
                  :to="'/keanggotaan/data-anggota/data-diri/'+this.$route.params.id_user"
                  class="nav-link text-dark"
                >Data Diri</router-link>
              </li>
              <li class="list-group-item">
                <router-link
                  :to="'/keanggotaan/data-anggota/data-anggota/'+this.$route.params.id_user"
                  class="nav-link text-dark"
                >Data Anggota</router-link>
              </li>
              <li class="list-group-item">
                <router-link
                  :to="'/keanggotaan/data-anggota/data-dokumen/'+this.$route.params.id_user"
                  class="nav-link text-dark"                  
                >Data Dokumen Pendukung</router-link>
              </li>
              <li class="list-group-item">
                <router-link
                  :to="'/keanggotaan/data-anggota/sanksi/'+this.$route.params.id_user"
                  style="color:#2F3AAA;font-weight:bold"
                  class="nav-link text-dark"
                >Data Sanksi</router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 mt-3 p-5">
          <div class="card">
            <div class="card-body">
              <div class="col-12">
                <label for="nama" class="font-weight-bold">Pilih Modul Sanksi</label>
                <div class="form-group">
                  <div class="icheck-warning d-inline mr-5">
                    <input type="checkbox" id="sertifikasi" v-model="formData.statusSanksiSertifikasi"/>
                    <label for="sertifikasi" style="font-size: 15px; margin-left: 4px"
                      >Sertifikasi</label
                    >
                  </div>
                </div>
                <div class="form-group">
                  <div class="icheck-warning d-inline mr-5">
                    <input type="checkbox" id="rpl" v-model="formData.statusSanksiRpl"/>
                    <label for="rpl" style="font-size: 15px; margin-left: 4px"
                      >RPL</label
                    >
                  </div>
                </div>
                <div class="form-group">
                  <div class="icheck-warning d-inline mr-5">
                    <input type="checkbox" id="pelatihan" v-model="formData.statusSanksiPelatihan"/>
                    <label for="pelatihan" style="font-size: 15px; margin-left: 4px"
                      >Pelatihan</label
                    >
                  </div>
                </div>
              </div>
              <div class="form-group col-12 mt-4">
                <label for="nama" class="font-weight-bold">Alasan</label>
                <textarea
                  name=""
                  class="form-control"
                  id=""
                  rows="5"
                  placeholder="Masukkan alasan"
                  v-model="formData.Alasan"
                  >
                </textarea>
              </div>
            </div>
            <div class="card-footer bg-white border-0 mb-3 mr-3 mb-3">
              <Button class="btn btn-md btn-success px-4 py-2 float-right" type="submit" color="success" @click="sanksiData" >Kirim</Button>
            </div>
          </div>
        </div>
      </CRow>
      
    </CCardBody>
  </CCard>
</template>
<script>
import SanksiAnggotaService from '@/services/keanggotaan/sanksi/sanksi-anggota.service';
import { AlertUtils } from "@/mixins/AlertUtils";
export default {
  mixins: [AlertUtils],
  data() {
    return {
      formData: {
        statusSanksiSertifikasi: false,
        statusSanksiRpl: false,
        statusSanksiPelatihan: false,
        alasan: '',        
        Alasan: '',        
        id_user: '',
      }
    }
  },
  mounted() {
    this.getData();
  },
 methods: {   
    sanksiData() {
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin?",
          icon: "info",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            this.actionPost == "update"
            this.putData(this.formData);
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    putData() {
      let loader = this.$loading.show({
          container: false ? null : this.$refs.formContainer,
          canCancel: false,
          onCancel: this.onCancel
        });
      // comment console console.log("put");
      // comment console console.log(this.$route.params.id_user);      
      var vm = this;
      vm.formData.id_user = this.$route.params.id_user;
      vm.formData.alasan =  vm.formData.Alasan
      SanksiAnggotaService.putDataSanksi(this.formData)
        .then((response) => {
          vm.alertSuccess();
          this.getData();
          loader.hide();
        })
        .catch((error) => {
          // comment console console.log(error);
          loader.hide();          
        });
    },

    getData(id_user) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      vm.formData.id_user = this.$route.params.id_user;      
      SanksiAnggotaService.getData(this.$route.params.id_user)
        .then(response => {
          // comment console console.log(response.data.singleData);
          vm.formData.alasan = response.data.singleData.Alasan;
          vm.formData = response.data.singleData;

          loader.hide();
        })
        .catch(error => {
          // comment console console.log(error);
          loader.hide();
        });
    },
 } 
}
</script>
